<template>

    <v-text-field height="20" class="ma-0 pa-1" hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
    ></v-text-field>

</template>

<script>

export default {

  props: ["value", "campo", "crud", "row", "modo"],    
  data() {
    return {
    };
  },
  methods: {
    
    preLoadFiltro(myval){     
      return myval;
    },    
    preUpdateFiltro(myval){
      return myval;
    }
  }
};
</script>

<style scoped>

</style>